export const DATE_HOURS_MINUTE_SECOND_FORMAT = "DD/MM/YYYY HH:mm:ss";
const MODULE_NAME = "SMS/";
export const BROWSE_REPORT = `${MODULE_NAME}BROWSE_REPORT/`;
export const PAGINATION = {
  limit: 20,
  offset: 1
};
